webpackJsonp([191319344601756],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	};
	
	var Form = function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      fetch('/', {
	        method: 'POST',
	        headers: { "Content-Type": "application/x-www-form-urlencoded" },
	        body: encode(_extends({
	          "form-name": 'swiss-contact-form'
	        }, _this.state))
	      }).then(function () {
	        _this.setState({
	          name: '',
	          email: '',
	          message: '',
	          phone: '',
	          bot: ''
	        });
	        alert('Success! Your message was successfully delivered!');
	      }).catch(function (error) {
	        return alert(error);
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  Form.prototype.render = function render() {
	    var _state = this.state,
	        name = _state.name,
	        email = _state.email,
	        message = _state.message,
	        phone = _state.phone;
	
	
	    return _react2.default.createElement(
	      'form',
	      {
	        name: 'swiss-contact-form',
	        method: 'post',
	        action: '/thanks/',
	        'data-netlify': 'true',
	        'data-netlify-honeypot': 'bot-field',
	        onSubmit: this.handleSubmit,
	        className: 'card'
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'swiss-contact-form', value: 'swiss-contact-form' }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'bot-field', onChange: this.handleChange }),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'name' },
	          'Name'
	        ),
	        _react2.default.createElement('input', {
	          value: name,
	          className: 'form-control',
	          type: 'text',
	          name: 'name',
	          id: 'name',
	          onChange: this.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'contact-mail' },
	          'EMAIL ADDRESS'
	        ),
	        _react2.default.createElement('input', {
	          value: email,
	          className: 'form-control',
	          type: 'email',
	          name: 'email',
	          id: 'email',
	          onChange: this.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'phone' },
	          'PHONE NUMBER'
	        ),
	        _react2.default.createElement('input', {
	          value: phone,
	          className: 'form-control',
	          type: 'tel',
	          name: 'phone',
	          id: 'phone',
	          onChange: this.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'message' },
	          'MESSAGE'
	        ),
	        _react2.default.createElement('textarea', {
	          value: message,
	          className: 'form-control',
	          name: 'message',
	          id: 'message',
	          onChange: this.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center mt-50' },
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', className: 'btn-main btn-alt' },
	          'SEND MESSAGE'
	        )
	      )
	    );
	  };
	
	  return Form;
	}(_react2.default.Component);
	
	exports.default = Form;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contactPageQuery = exports.ContactPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Form = __webpack_require__(216);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPageTemplate = exports.ContactPageTemplate = function ContactPageTemplate(_ref) {
	  var title = _ref.title,
	      html = _ref.html;
	
	  return _react2.default.createElement(
	    'main',
	    { id: 'main', className: 'site-main' },
	    _react2.default.createElement(
	      'div',
	      { className: 'hero hero-subpage strong-overlay' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-content text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'h-80 weight-bold' },
	            title
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'p-24' },
	            'Feel free to contact us.'
	          )
	        )
	      ),
	      _react2.default.createElement('div', {
	        className: 'contact-content',
	        dangerouslySetInnerHTML: { __html: html }
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'section-contact-us' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container container-1010' },
	          _react2.default.createElement(_Form2.default, null)
	        )
	      )
	    )
	  );
	};
	
	ContactPageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	var ContactPage = function ContactPage(_ref2) {
	  var data = _ref2.data;
	  var _data$markdownRemark = data.markdownRemark,
	      frontmatter = _data$markdownRemark.frontmatter,
	      html = _data$markdownRemark.html;
	
	
	  return _react2.default.createElement(ContactPageTemplate, {
	    html: html,
	    title: frontmatter.title
	  });
	};
	
	ContactPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = ContactPage;
	var contactPageQuery = exports.contactPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-contact-page-js-1d845fefa217591ea422.js